<div>
  <mat-card class="dashboard-card">
    <mat-card-content class="dashboard-card-content">
      <ng-content></ng-content>
    </mat-card-content>
  </mat-card>
</div>
